export default "__VITE_PUBLIC_ASSET__5ccfa02b__"